import React from 'react';
import { Button, Card } from 'antd';
import PropTypes from 'prop-types';
import {
  Flex, Text,
} from '../../shared/components';
import SelectBox from '../../shared/components/dataEntry/SelectBox';

export default function SearchContainer(props) {
  const {
    filters, values, onSearchClick, onFilterSelect,
  } = props;
  const onFilterSelectHandler = (tipo, selection) => {
    onFilterSelect({ tipo, value: selection });
  };
  return (
    <Card bordered={false} m="16px 0" title={<Text color="#3E3E3C" fontWeight="bold" fontSize="16px" translationId="generico.busqueda">Busqueda</Text>}>
      <Flex width="100%">
        <SelectBox
          onSelect={selection => onFilterSelectHandler('tipoArticulo', selection)}
          sortBy={{ nombre: 'DESC' }}
          filterBy="nombre"
          label={{ translationId: 'articulos', value: 'Artículos' }}
          keys={{ id: 'id', descripcion: 'nombre' }}
          values={[{ id: -1, nombre: 'TODOS LOS TIPOS', descripcion: 'TODOS LOS TIPOS' }, ...values.tiposArticulo]}
          selection={filters.tipoArticulo}
          loading={!values.tiposArticulo || values.tiposArticulo.length === 0}
        />
        <SelectBox
          onSelect={selection => onFilterSelectHandler('tienda', selection)}
          sortBy={{ nombre: 'DESC' }}
          filterBy="nombre"
          label={{ translationId: 'generico.tiendas', value: 'Tiendas' }}
          keys={{ id: 'id', descripcion: 'nombre' }}
          values={values.tiendas}
          selection={filters.tienda}
          loading={!values.tiendas || values.tiendas.length === 0}
        />
        <SelectBox
          onSelect={selection => onFilterSelectHandler('proveedor', selection)}
          sortBy={{ nombre: 'DESC' }}
          filterBy="nombre"
          label={{ translationId: 'generico.proveedores', value: 'Proveedores' }}
          keys={{ id: 'id', descripcion: 'nombre' }}
          values={values.proveedores}
          selection={filters.proveedor}
          loading={!values.proveedores || values.proveedores.length === 0}
        />
        <Flex flexDirection="column" mr="16px" alignSelf="flex-end">
          <Button icon="search" size="large" type="primary" onClick={() => onSearchClick({ current: 1, pageSize: 8 })}><Text ml="8px" translationId="generico.buscar">Buscar</Text></Button>
        </Flex>
      </Flex>
    </Card>
  );
}
SearchContainer.propTypes = {
  filters: PropTypes.shape({
    tipoArticulo: PropTypes.shape({}),
    tienda: PropTypes.shape({}),
    proveedor: PropTypes.shape({}),
  }).isRequired,
  values: PropTypes.shape({
    tiposArticulo: PropTypes.arrayOf(PropTypes.shape({})),
    tiendas: PropTypes.arrayOf(PropTypes.shape({})),
    proveedores: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  onSearchClick: PropTypes.func.isRequired,
  onFilterSelect: PropTypes.func.isRequired,
};
